(() => {
  const bindSlideInert = (swiper) => {
    if (!swiper || typeof swiper.on !== 'function') return;

    const sync = () => {
      if (!swiper.slides) return;
      Array.from(swiper.slides).forEach((slide) => {
        const visible =
          typeof slide.isVisible === 'boolean'
            ? slide.isVisible
            : slide.classList.contains('swiper-slide-visible');
        if (visible) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    };

    swiper.on('init', sync);
    swiper.on('afterInit', sync);
    swiper.on('slideChange', sync);
    swiper.on('transitionEnd', sync);
    swiper.on('resize', sync);
    swiper.on('breakpoint', sync);
    swiper.on('slidesUpdated', sync);
    sync();
  };

  if (typeof window.customElements.get('band-upsells') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'band-upsells',
    class BandUpsells extends HTMLElement {
      constructor() {
        super();

        this.swiperContainer = this.querySelector('[data-band-upsells-swiper-container]');
        this.navNextButton = this.querySelector('[data-band-upsells-nav-next]');
        this.navPrevButton = this.querySelector('[data-band-upsells-nav-prev]');

        this.initBandUpsells();
      }

      initBandUpsells() {
        try {
          this.setupSwiper();
        } catch (error) {
          console.error('There was a problem with the BandUpsells component:', error);
        }
      }

      setupSwiper() {
        if (!this.swiperContainer) {
          return;
        }

        const bandUpsellsSwiper = new Swiper(this.swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          centeredSlides: true,
          loop: false,
          rewind: true,
          watchSlidesProgress: true,
          a11y: { enabled: true },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          breakpoints: {
            750: {
              spaceBetween: 24,
            },
          },
          navigation: {
            nextEl: this.navNextButton,
            prevEl: this.navPrevButton,
          },
        });

        bindSlideInert(bandUpsellsSwiper);

        return bandUpsellsSwiper;
      }
    }
  );
})();
